type FlatMap = Record<string, string>;

export class LangHelper {
    public static dynamicMap: Record<string, FlatMap> = {};
    static defaultLang = 'vi';

    static setDynamic(
        map:
            | Record<string, string>
            | Record<string, { translateText: string }> = {},
        lang: string
    ) {
        if (map === null || typeof map !== 'object') {
            console.warn('[LangHelper] setDynamic invalid map:', map);

            return;
        }

        const l = lang.toLowerCase(); // → 'en' | 'vi'
        const flat: FlatMap = {};

        Object.entries(map ?? {}).forEach(([key, val]) => {
            flat[key] = typeof val === 'string' ? val : val.translateText;
        });

        this.dynamicMap[l] = flat;
        this.defaultLang = l;
    }

    /**
     * Lookup a translation by key and optional context, using only if statements.
     * @param key     Base translation key, e.g. "HomePage"
     * @param context Optional context suffix, e.g. "title"
     * @returns       The translated string or fallback to key
     */
    static trans(key: string, context?: string): string {
        const langCode = this.defaultLang;
        const fullKey = context ? `${key}.${context}` : key;

        if (
            this.dynamicMap[langCode] &&
            this.dynamicMap[langCode][fullKey] !== undefined
        ) {
            return this.dynamicMap[langCode][fullKey];
        }

        return key;
    }
}

export function t(key: string, context?: string) {
    return LangHelper.trans(key, context);
}
